import React from 'react'
import { Route, IndexRoute } from 'react-router'
import Splitter from '../helpers/Splitter'

import EventPurchaseContainer from '../components/common/events/EventPurchaseContainer'

import EventCreateUpdate from '../components/common/events/EventCreateUpdate'

const Index = Splitter(() => import('../components/common/events/Index'))

// import EditEvent from "../components/common/events/EditEvent";

// const AddEvent = Splitter(() => import('../components/common/events/AddEvent'))

// const ViewEventVideo = Splitter(() =>
//   import('../components/common/events/ViewEventVideo')
// )

const EventsContainer = Splitter(() =>
  import('../components/common/events/EventsContainer')
)

const ReviewEvent = Splitter(() => import('../components/manager/ReviewEvent'))

const MyEventsContainer = Splitter(() => import('../components/common/events/MyEvents/MyEventsContainer'))

export const eventsRoutes = (
  <Route path="events" component={EventsContainer}>
    <IndexRoute component={Index} />
    <Route path="my-events" component={MyEventsContainer} />
    <Route path="add" component={EventCreateUpdate} />
    <Route path="edit/:eventId" component={EventCreateUpdate} />
    <Route path=":eventId/purchase/:eventCode" component={EventPurchaseContainer} />
    <Route path="review/:eventId" component={ReviewEvent} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/eventsRoutes.js